export default "__VITE_ASSET__B1G07Aq6__"